forms-heat_treatments-save  
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.name")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.name_alt")
    inputs-submit(tag-scope="{ this.tagScope }.inputs.submit")
  script(type="typescript").
    this.mixin('forms.heat_treatments.save')
